import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { AlertDialogService } from "../../components/_alert-dialog/alert-dialog.service";
import { HttpService } from "../../services/http.service";
import { ToolsService } from "../../services/tools.service";
import { TypeBanque } from "../../interfaces/TypeBanque";
import { TypeBanqueDialogService } from "../../dialogs/type-banque-dialog/type-banque-dialog.service";

@Component({
  selector: "select-type-banque",
  templateUrl: "select-type-banque.html",
  standalone: false,
})
export class SelectTypeBanque implements OnInit {
  @Input() ngModel: number = 0;
  @Input() disabled?: boolean = false;
  @Input() enableCreate?: boolean = false;
  @Input() enableEdit?: boolean = false;

  @Output() ngModelChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  public oLogUser = JSON.parse(sessionStorage.getItem("Equora_User"));
  public elements: TypeBanque[];
  public filteredElements: ReplaySubject<TypeBanque[]> = new ReplaySubject<
    TypeBanque[]
  >(1);
  public bLoad: boolean;

  constructor(
    private _http: HttpService,
    private _tools: ToolsService,
    private _alert: AlertDialogService,
    private _s: TypeBanqueDialogService
  ) {}

  ngOnInit(): void {
    this.getElements();
  }

  getElements(): void {
    this.bLoad = true;
    this._http.GET(
      "/api/typebanque",
      null,
      (result) => {
        if (result.isOk) {
          this.elements = result.obj;
          this.filteredElements.next(this.elements.slice());
          this.change();
        } else {
          this._alert.openDialog(
            "Erreur",
            { message: result.message },
            "error"
          );
        }
        this.bLoad = false;
      },
      (error) => {
        this._tools.showHttpError(error);
        this.bLoad = false;
      }
    );
  }

  search(
    search: string,
    elements: TypeBanque[],
    filteredElements: ReplaySubject<TypeBanque[]>
  ) {
    if (!search) {
      filteredElements.next(elements.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filteredElements.next(
      elements.filter(
        (e) =>
          (e.typeBanque_Code + " - " + e.typeBanque_Libelle)
            .toLowerCase()
            .indexOf(search) > -1
      )
    );
  }

  change(): void {
    this.ngModelChange.emit(this.ngModel);
    const selected = this.elements.find((e) => e.typeBanque_ID == this.ngModel);
    this.selectionChange.emit(selected ?? null);
  }

  open(id: number) {
    this._s.openDialog(id, () => {
      this.getElements();
    });
  }
}
